const APP_LOCALE_ZH = 'zh-CN';
const APP_LOCALE_EN = 'en-US';
const APP_LOCALE_KO = 'ko-KR';

const locales = {
  'zh': APP_LOCALE_ZH,
  'zh-CN': APP_LOCALE_ZH,
  'en': APP_LOCALE_EN,
  'en-US': APP_LOCALE_EN,
  'ko': APP_LOCALE_KO,
  'ko-KR': APP_LOCALE_KO,
};

export default locales;

export const getLocaleAttr = (locale: string) => {
  let obj = {
    journalLabelSpan: 7,
    ganttChartmarginLeft: {},
    help: '帮助中心',
    projectDetailSingle: '任务单详情页',
    alertMaxWidth: 567,
  };

  switch (locale) {
    case 'en':
      obj = {
        ...obj,
        journalLabelSpan: 10,
        ganttChartmarginLeft: { left: 90 },
        help: 'Guide',
        projectDetailSingle: 'Project detail',
        alertMaxWidth: 610,
      };
      break;
    default:
      break;
  }

  return obj;
};
